import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';

// Preferencia de modo oscuro: por navegador (localStorage), no por usuario ni
// por sucursal — cada quien lo prende si quiere, sin afectar a nadie más.
const ModoOscuroContext = createContext({ oscuro: false, toggleModoOscuro: () => {} });

export function ModoOscuroProvider({ children }) {
  const [oscuro, setOscuro] = useState(() => localStorage.getItem('modo_oscuro') === '1');

  useEffect(() => {
    localStorage.setItem('modo_oscuro', oscuro ? '1' : '0');
  }, [oscuro]);

  const value = useMemo(() => ({
    oscuro,
    toggleModoOscuro: () => setOscuro((v) => !v),
  }), [oscuro]);

  return <ModoOscuroContext.Provider value={value}>{children}</ModoOscuroContext.Provider>;
}

export const useModoOscuro = () => useContext(ModoOscuroContext);
